module.exports = __webpack_public_path__ + "media/recipes/6-df055016.png";